export default __webpack_public_path__ + "static/media/computermaintenance.4cad45c9.jpg";